
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["info-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24.543 24.543"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 540","transform":"translate(1 1)","stroke-width":"2","stroke":"#ffb3a6","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}},[_c('circle',{attrs:{"data-name":"Ellipse 41","cx":"11.272","cy":"11.272","r":"11.272"}}),_c('path',{attrs:{"data-name":"Linie 4","d":"M10.884 9.674v7.773"}}),_c('path',{attrs:{"data-name":"Linie 5","d":"M10.884 4.982v.858"}})])])
          )
        }
      }
    